import { useEffect } from "react";

import { useToast } from "@/react/components/SettingsApp/CompassCompat/Toast";

interface RailsFlashMessagesProps {
  alert: string | null;
  notice: string | null;
}

export const RailsFlashMessages = ({
  alert,
  notice,
}: RailsFlashMessagesProps) => {
  const { success, error } = useToast();

  useEffect(() => {
    if (alert) {
      error(alert);
    }
    if (notice) {
      success(notice);
    }
  }, []);

  return null;
};
